<div class="row mt-3">
    <div class="col-md-3"></div>
    <div class="col-md-6">
        <div class="alert alert-success" role="alert">
            <h4 class="alert-heading">Proceso de matrícula.</h4>
            <p class="mb-0">
            En unos momentos ser&aacute;s redirigido autom&aacute;ticamente.
            </p>
            <p>Estamos procesando la firma de tu contrato, una vez realizada ésta validación te
                 enviaremos el contrato a tu correo electrónico. Este proceso dura 2 minutos.</p>
            <hr />
            <p class="mb-0"></p>
        </div>
    </div>
    <div class="col-md-3"></div>
</div>
